import { Checkbox, Col, Divider, Drawer, Row, Typography } from 'antd';
import PropTypes from 'prop-types';
import React from 'react';
//
import CustomScrollbars from 'util/CustomScrollbars';

const FilterList = ({ showFilter, setShowFilter, uiFilters, setUiFilters, items, dynamicGroupName }) => {
  return (
    <Drawer
      placement="right"
      closable={false}
      onClose={() => setShowFilter(false)}
      visible={showFilter}
    >
      <CustomScrollbars className="gx-customizer">
        <Checkbox.Group
          onChange={(e) => setUiFilters(e)}
          defaultValue={uiFilters}
        >
          <Row>
            {
              Object.keys(items).map((item, index) => {
                return (
                  <Col
                    key={`filter-check-box-${index}`}
                    span={16}
                    className="gx-m-2"
                  >
                    <Checkbox value={item} > {item} </Checkbox>
                  </Col>
                );
              })
            }
          </Row>

          {dynamicGroupName && (
            <>
              <Divider style={{ margin: '24px 0' }} />
              <Typography.Title level={5}>Dynamic Groups</Typography.Title>
              {Object.keys(dynamicGroupName || {}).map((groupKey, index) => {
                const group = dynamicGroupName[groupKey];
                return (
                  <Row key={`dynamic-group-${groupKey}-${index}`}>
                    <Col
                      key={`dynamic-filter-check-box-${groupKey}`}
                      span={16}
                      className="gx-m-2"
                    >
                      <Checkbox value={groupKey}> {group.name} </Checkbox>
                    </Col>
                  </Row>
                );
              })}
            </>
          )}
        </Checkbox.Group>
      </CustomScrollbars>
    </Drawer >
  );
};

FilterList.propTypes = {
  items: PropTypes.object,
  showFilter: PropTypes.bool,
  setShowFilter: PropTypes.func,
  uiFilters: PropTypes.array,
  setUiFilters: PropTypes.func,
  dynamicGroupName: PropTypes.object
};

export default FilterList;
